import z from "zod";

/**
 * ObraChecklistServicoSchema
 */

export const ObraChecklistServicoSchema = z.object({
  tipoServico: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }),
  checklistServicos: z.array(z.number()).nonempty('Este campo deve ser preenchido!'),
});

/**
 * ObraChecklistServicoForm
 */

export type ObraChecklistServicoForm = z.infer<typeof ObraChecklistServicoSchema>;

/**
 * initialObraChecklistServico
 */

export const initialObraChecklistServico: Partial<ObraChecklistServicoForm> = {
  tipoServico: 2,
};